import About from "./Pages/About";
import Home from "./Pages/Home";
import Navbar from "./components/Navbar/Navbar";
import Footer from './components/Footer/Footer'
import {BrowserRouter, Switch, Route } from 'react-router-dom'
import Contact from "./Pages/Contact/Contact";
import ScrollTop from "./components/ScrollTop/ScrollTop";

function App() {
  return (
    <BrowserRouter>
        <ScrollTop />
        <Navbar />
        <Switch>
          <Route exact path="/" component={Home} />
          <Route path="/about" component={About} />
          <Route path="/contact" component={Contact} />
        </Switch>
        <Footer />
    </BrowserRouter>
  );
}

export default App;
